import { node } from "~/util/dom";
import { _ } from "~/i18n";
import { CONFIG } from "~/config";
import { IMapState } from "~/state/map/interfaces";
import { isPointInStatePolygon } from "~/util/state-polygon";
import { debounce } from "~/lib/debounce";

const JOINER = " | ";
const OPENSTREETMAP = "openstreetmap";
const OPENSTREETMAP_LINK = `<a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">`;

export default class ControlCopyright {
	_dom: {
		[key: string]: HTMLElement;
	};

	_setDataCb: (data: IMapState) => void;

	constructor() {
		this._dom = {};
		this._dom.container = node("div", { className: "control-copyright print" });
		this._setDataCb = debounce((data: IMapState) => {
			this._setData(data);
		}, 500);
	}

	get container() {
		return this._dom.container;
	}

	setData(data: IMapState) {
		this._setDataCb(data);
	}

	async _setData(data: IMapState) {
		const { copyrights: copyrightsStore, ophotoDate, longitude, latitude } = data;
		const copyrights = [
			...copyrightsStore,
		];
		const isCzech = await isPointInStatePolygon(longitude, latitude, {
			cs: true,
		});

		if (!isCzech) {
			const ind = copyrights.findIndex(item => item.includes(OPENSTREETMAP));

			if (ind !== -1) {
				copyrights.splice(ind, 1);
			}

			copyrights[0] = `${copyrights[0]}, ${_("copyright.openstreetmap", {
				linkStart: OPENSTREETMAP_LINK,
				linkEnd: "</a>",
			})}`;
		}

		const copyrightTxt = `&copy; ${copyrights.slice(0, 1).join(" | ")} ${_("m3d.andOthers")}`;

		// do title odstranime tagy + veci typu &XYZ;
		this._dom.container.title = copyrights.join(JOINER).replace(/<[^>]+>|&[^;]+;/gu, "");

		// vypis
		this._dom.container.innerHTML = copyrightTxt + (ophotoDate ? ` | ${ophotoDate}` : "") + (CONFIG.inFrame ? ` | ${_("copyright.licence")}` : "");

		const link = this._dom.container.querySelector("a[data-others='1']");

		if (link) {
			const lang = CONFIG.defaultLang === "cs" ? "" : `&lang=${CONFIG.defaultLang}`;

			link.setAttribute("target", "_blank");
			link.setAttribute("rel", "noopener");
			link.setAttribute("href", `https://licence.mapy.cz/?doc=mapy_attr${lang}`);
		}
	}
}
